module.exports = __webpack_public_path__ + "img/indexImg.d2f8edc5.jpg";